import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TimezoneOnboardingStore } from '../../shared/store/timezone-onboarding.store';
import { VendorDateTimeService } from './vendor-datetime.service';

@Injectable({
  providedIn: 'root',
})
export class TimezoneNavigationService {
  private readonly router = inject(Router);
  private readonly vendorDateTimeService = inject(VendorDateTimeService);
  private readonly timezoneOnboardingStore = inject(TimezoneOnboardingStore);

  isAllowedWithoutTimezone(url: string): boolean {
    const path = this.normalizeUrl(url);
    return path === '/dashboard' || path === '/' || path === '';
  }

  blockNavigationIfNeeded(targetUrl: string): boolean {
    if (!this.vendorDateTimeService.isTimeZoneMissing()) {
      return false;
    }

    if (this.isAllowedWithoutTimezone(targetUrl)) {
      return false;
    }

    this.timezoneOnboardingStore.open();

    if (!this.isAllowedWithoutTimezone(this.router.url)) {
      void this.router.navigate(['/dashboard']);
    }

    return true;
  }

  private normalizeUrl(url: string): string {
    const path = url.split('?')[0].split('#')[0];
    if (!path || path === '/') {
      return '/';
    }

    return path.startsWith('/') ? path : `/${path}`;
  }
}
